import { getItemFromLocalStorage } from "./getLocalStorageItem";

export const getThemeFromStorage = (companyId) => {
  const id = companyId ?? getItemFromLocalStorage("companyId");
  if (!id) return null;
  try {
    const raw = localStorage.getItem(`theme_${id}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const toAbsoluteLogoUrl = (url) => {
  if (!url || typeof url !== "string") return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  const origin = window.location.origin.replace(/\/$/, "");
  return `${origin}${trimmed.startsWith("/") ? "" : "/"}${trimmed}`;
};

export const getThemeLogoConfig = (companyId) => {
  const theme = getThemeFromStorage(companyId);
  if (!theme) return null;

  const width = theme.logoWidth != null && theme.logoWidth !== "" ? Number(theme.logoWidth) : null;
  const height = theme.logoHeight != null && theme.logoHeight !== "" ? Number(theme.logoHeight) : null;

  return {
    logoUrl: toAbsoluteLogoUrl(theme.logoUrl) || null,
    logoWidth: Number.isFinite(width) && width > 0 ? width : null,
    logoHeight: Number.isFinite(height) && height > 0 ? height : null,
    logoNameLine1: (theme.logoNameLine1 || "").trim(),
    logoNameLine2: (theme.logoNameLine2 || "").trim(),
  };
};

export const hasLogoTextLayout = (config) =>
  Boolean(config?.logoNameLine1 || config?.logoNameLine2);
